import React from "react";
import { FTLBasicSelect } from "./FTLBasicSelect";
export const FTLSelect = (props) => {
    return React.createElement(FTLBasicSelect, Object.assign({}, props));
};
//# sourceMappingURL=FTLSelect.js.map